import React, { Suspense, lazy, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useScrollToTop from "./hooks/useScrollToTop.js";
import i18n from "i18next";

// !====== Core Pages =====! //
const MainLayouts = lazy(() =>
    import ("./layouts/MainLayouts.jsx"));
const HomePage = lazy(() =>
    import ("./page/home.jsx"));
const ContactPage = lazy(() =>
    import ("./page/contact.jsx"));
const AboutUsPage = lazy(() =>
    import ("./page/AboutUs.jsx"));
const CertificationPage = lazy(() =>
    import ("./page/certification.jsx"));
const ProductPage = lazy(() =>
    import ("./page/productPage.jsx"));
const DetailProduct = lazy(() =>
    import ("./page/detailProduct.jsx"));
const DetailProject = lazy(() =>
    import ("./page/detailProject.jsx"));

const JobPage = lazy(() =>
    import ("./page/jobPage.jsx"));
const DetailBlog = lazy(() =>
    import ("./page/DetailBlog.jsx"));
const Blog = lazy(() =>
    import ("./page/blogPage.jsx"));
const ProjectPage = lazy(() =>
    import ("./page/projectPage.jsx"));
const Morefeedback = lazy(() =>
    import ("./page/moreCustomerFeedback.jsx"));
const JobDescriptionPage = lazy(() =>
    import ("./page/jobDescriptionPage.jsx"));

function App() {
    useScrollToTop();
    // keep <html lang/dir> in sync with the selected language
    useEffect(() => {
        const apply = () => {
            document.documentElement.lang = i18n.language;
            document.documentElement.dir = i18n.language === "en" ? "ltr" : "rtl";
        };
        apply();
        i18n.on("languageChanged", apply);
        return () => i18n.off("languageChanged", apply);
    }, []);

    return ( <
        div >
        <
        Suspense fallback = { <div style={{ minHeight: "100vh" }} /> } > { " " } <
        MainLayouts>
        <Routes >
        <
        Route path = "/"
        element = { < HomePage / > }
        />{" "} <
        Route path = "/contact-us"
        element = { < ContactPage / > }
        />{" "} <
        Route path = "/about-us"
        element = { < AboutUsPage / > }
        />{" "} <
        Route path = "/certification"
        element = { < CertificationPage / > }
        />{" "} <
        Route path = "/product"
        element = { < ProductPage / > }
        />{" "} <
        Route path = "/project"
        element = { < ProjectPage / > }
        />{" "} <
        Route path = "/product-detail/:id"
        element = { < DetailProduct / > }
        />
        <
        Route path = "/project-detail/:id"
        element = { < DetailProject / > }
        />{" "} <
        Route path = "/blogs"
        element = { < Blog / > }
        />{" "} <
        Route path = "/job"
        element = { < JobPage / > }
        />{" "} <
        Route path = "/job-description/:id"
        element = { < JobDescriptionPage / > }
        />{" "} <
        Route path = "/blog-detail/:id"
        element = { < DetailBlog / > }
        />{" "} <
        Route path = "/feedback"
        element = { < Morefeedback / > }
        />{" "} <
        Route path = "*"
        element = { < Navigate to = "/" / > }
        />{" "} < /
        Routes > { " " } <
        /MainLayouts>{" "} < /
        Suspense > { " " } <
        /div>
    );
}

export default App;